import { Component, OnInit, EventEmitter, ViewChild, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { QuestionnaireService } from '../../services/questionnaire/questionnaire.service';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { MetricIconService } from 'src/app/services/metrics/metrics-icons.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import * as Cookies from 'js-cookie';
import { ConstantsService } from "../../services/constants/constants.service";



@Component({
  selector: 'app-add-question-modal',
  templateUrl: './add-question-modal.component.pug',
  styleUrls: ['./add-question-modal.component.scss'],
  standalone: false
})


  export class AddQuestionModalComponent implements OnInit {
    type = 'exit';
    showAnswers = false;
    helpToggle = false;
    loading = false;
    createCustomQuestion = false;
    selectedQuestions: any[] = [];
    previouslySelected: any[] = [];
    checkboxOption: any[] = [];
    questions: any[] = [];
    filterQuestions: any[] = [];
    questionClass = {};
    metrics: any[] = [];
    searchValue="";
    selectedMetric = "";
    selectedMetricLabel = "All Metrics";
    org_name='';
    org_name_placeholder='{organisation}';
    createCustomQuestionTooltip = $localize`Upgrade to enable this feature. Click to request access.`;
    @ViewChild('questionList') questionList:any;
    addClick: EventEmitter<any> = new EventEmitter<any>();
    helpClick: EventEmitter<any> = new EventEmitter<any>();
    createClick: EventEmitter<any> = new EventEmitter<any>();
    editQuestionClick: EventEmitter<any> = new EventEmitter<any>();
    deleteQuestionClick: EventEmitter<any> = new EventEmitter<any>();
    hideQuestionClick: EventEmitter<any> = new EventEmitter<any>();
    searchOptions = [{'label':$localize`Question`,'value':'title', 'hint':$localize`Specific question`},];
    selectedColumns: any = [];
    sortCriteriaComp = {
      sortOptions: [
        {
          'key': $localize`Question name`,
          'value': [
            {'label': $localize`A-Z`, 'sortString': 'text'},
            {'label': $localize`Z-A`, 'sortString': '-text'}
          ]
        },
        {
          'key': 'group-end',
          'value': []
        },
        {
          'key': $localize`Times used`,
          'value': [
            {'label': $localize`Most frequent`, 'sortString': 'count'},
            {'label': $localize`Least frequent`, 'sortString': '-count'}
          ]
        },
      ],
      sortOutput: ''
    }
    sortCriteria = {
      sortOptions: [
        {
          'label': $localize`Question name`,
          'type': "word",
          'value': "text"
        },
        {
          'label': $localize`Times used`,
          'type': "frequency",
          'value': "count"
        }
      ],
      sortString: '-created',
      sortOrder: '',
      sortOutput: ''
    }
    filterCheckboxOptions = [
        {
          'label': $localize`Verified only`,
          'value': 'is_verified',
          'icon': 'https://assets.xref.com/omni/shared/verified_tag_without_background_forest.svg'
        },
        {
          'label': $localize`Insights only`,
          'value': 'is_measured',
          'icon': 'https://assets.xref.com/omni/shared/insights_tag_without_background.svg'
        },
    ];
    filterStatusTitle = $localize`Metrics`;
    filterStatusOptions: any = [];
    selectedGroup: any = 'All';
    saveDisable=false;
    contactLink = ConstantsService.CONTACT_US;
    canManage = false;

    constructor( public bsModalRef: BsModalRef,
        private metricIconService: MetricIconService,
        private questionnaireService: QuestionnaireService,
        private organisationService:OrganisationService,
        private permission: PermissionsService
        // @Inject(LOCALE_ID) public locale: string,
        ) { }

    ngOnInit() {
        this.createCustomQuestion = this.permission.isOrgFeatureEnabled('custom_question');

        // @ts-ignore
        if (this.type === 'pulse') {
          this.filterCheckboxOptions = [
              {
                'label': $localize`Verified only`,
                'value': 'is_verified',
                'icon': 'https://assets.xref.com/omni/shared/verified_tag_without_background_forest.svg'
              }
            ]
        }
        this.organisationService.getOrganisation().subscribe(res => {
            this.org_name = res['brand_name'];
        })
        let metric_type = this.type!='exit' && this.type!='pulse' ? 'reference' : this.type;
        this.questionnaireService.getMetrics(metric_type).subscribe(
            res=>{
                this.metrics = res;
                this.filterStatusOptions = this.metrics.map(metric=>{
                   return {
                       "label": metric.name,
                       "value": metric.id,
                       "count": 0
                   }
                });
            }
        )
        this.loading=true;
        let type = (this.type!='candidate'&&this.type!='exit'&&this.type!='pulse') ? 'reference' : this.type;
        this.questionnaireService.getQuestions("","",[],"",type).subscribe(
            res=>{
                this.questions = res['data'];
                this.setQuestionClass();
            }
        )
    }

    getMetricIcon(metric) {
        return this.metricIconService.getMetricIcon(metric);
    }


    setQuestionClass() {
        if (this.questionList) this.questionList.nativeElement.scrollTop = 0;
        this.questions.forEach(question =>{
            if (this.previouslySelected.findIndex(selectedQuestion=>selectedQuestion.id==question.id)>=0){
                this.questionClass[question.id] = 'disabled';
            } else if (this.selectedQuestions.findIndex(selectedQuestion=>selectedQuestion.id==question.id)>=0){
                this.questionClass[question.id] = 'selected';
            } else {
              if(!this.createCustomQuestion && question.is_custom){
                this.questionClass[question.id]='disabled';
              }
              else{this.questionClass[question.id]=''}

            }
        })
        this.loading = false;
    }

    onSelectQuestion(question) {
        if (this.questionClass[question.id] == 'disabled') return;
        if (this.questionClass[question.id] == ''){
            this.selectedQuestions.push(question);
            this.questionClass[question.id] = 'selected';
        } else {
            const index = this.selectedQuestions.findIndex(selctedQuestion=>{
                return question.id == selctedQuestion.id;
            });
            this.selectedQuestions.splice(index, 1);
            this.questionClass[question.id] = '';
        }
    }

    onSearchChange(event){
        if (event && event['data']){
            this.searchValue = event['data']['search'][0]['value'];
        }else{
            this.searchValue = '';
        }
        let sortOutput = '';
        sortOutput = this.sortCriteriaComp['sortOutput'];
        this.getQuestions(this.selectedMetric, this.checkboxOption, sortOutput);
    }
    onSortChange(event){
        // connect to BE
      let sortOutput = event;
      this.sortCriteriaComp['sortOutput'] = event['sortString'];
      sortOutput = event['sortString']

      this.getQuestions(this.selectedMetric, this.checkboxOption, sortOutput);
    }

    onFilterUpdate(event){
        // Connect to BE
        this.selectedMetric = event['statusOption'].join(',');
        this.checkboxOption = event['checkboxOption'];
        this.selectedGroup = event['selectedGroup'];
        let sortOutput = '';
        sortOutput = this.sortCriteriaComp['sortOutput'];
        this.getQuestions(this.selectedMetric, this.checkboxOption, this.sortCriteria['sortOutput'], this.selectedGroup);
    }
    openCloseHelp(){
        this.helpToggle = !this.helpToggle;
        this.helpClick.emit(this.helpToggle);
    }

    getQuestions(metrics="", checkbox:any=[], sortOutput="", group=""){
        // Update search string to placeholder so BE can return with response
        this.loading = true;
        let type = (this.type!='candidate'&&this.type!='exit'&&this.type!='pulse') ? 'reference' : this.type;
        let searchValue = this.searchValue.replace(this.org_name, this.org_name_placeholder);
        searchValue = searchValue.replace(this.org_name_placeholder+'\'s', this.org_name_placeholder);
        searchValue = searchValue.replace(this.org_name_placeholder+' ', this.org_name_placeholder);
        searchValue = searchValue.replace(' '+this.org_name_placeholder, this.org_name_placeholder);
        this.questionnaireService.getQuestions(searchValue, metrics, checkbox, sortOutput, type, group).subscribe(res=>{
            this.questions = res['data'];
            this.setQuestionClass();
        })
    }

    add(){
        this.saveDisable=true;
        this.addClick.emit({data: this.selectedQuestions});
        this.bsModalRef.hide();
    }

    cancel(){
        this.bsModalRef.hide();
    }
    
    createCustomClick(){
        if (!this.createCustomQuestion) {
            // if user or org is not allowed to create the custom question,
            // then user is redirected to page of Contact account manager
            window.open(this.contactLink, "_blank");
        } else {
            this.createClick.emit(this.type);
            this.bsModalRef.hide();
        }
    }
    editClick(question){
        this.editQuestionClick.emit(question);
        this.bsModalRef.hide();
    }
    deleteClick(question){
        this.deleteQuestionClick.emit(question);
        this.bsModalRef.hide();
    }
    hideClick(question){
        this.hideQuestionClick.emit(question);
        this.bsModalRef.hide();
    }
  }
